class CartDrawer extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.setHeaderCartIconAccessibility();

    if (this.querySelector('#CartDrawer')) {
      this.loaded = true;
      this.bindEvents();
    }
  }

  bindEvents() {
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    const overlay = this.querySelector('#CartDrawer-Overlay');
    if (overlay) overlay.addEventListener('click', this.close.bind(this));
  }

  loadCartDrawerSection(callback){
    let self = this;
    const sections = this.getSectionsToRender().map(s => s.id).join(',');

    fetch(`${window.location.pathname}?sections=${sections}`)
    .then((response) => {
      return response.text();
    })
    .then(function (data) {
      let results = JSON.parse(data);

      self.getSectionsToRender().forEach((section => {
        const elementID = document.getElementById(section.id);
        let sectionElement = elementID;
        if (elementID && section.selector) {
          sectionElement = elementID.querySelector(section.selector) || elementID;
        }
        
        // If the section element doesn't exist (e.g. initial load of empty drawer), 
        // and we're targeting the cart-drawer, use the custom element itself
        if (!sectionElement && section.id === 'cart-drawer') {
          sectionElement = self;
        }

        if (sectionElement && results[section.id]) {
          const doc = new DOMParser().parseFromString(results[section.id], 'text/html');
          const newElement = section.selector ? doc.querySelector(section.selector) : doc.querySelector('.shopify-section');
          
          if (newElement) {
            sectionElement.innerHTML = newElement.innerHTML;
            
            // Sync classes if we are updating the cart-drawer element itself
            if (section.id === 'cart-drawer' || sectionElement.tagName.toLowerCase() === 'cart-drawer') {
              const classesToKeep = ['active', 'animate'];
              const currentClasses = Array.from(sectionElement.classList).filter(c => classesToKeep.includes(c));
              sectionElement.className = newElement.className;
              currentClasses.forEach(c => sectionElement.classList.add(c));
            }
          } else {
            sectionElement.innerHTML = self.getSectionInnerHTML(results[section.id], section.selector);
          }
        }
      }));

      if(!self.loaded){
        self.loaded = true;
        self.bindEvents();
        if (!customElements.get('cart-items')) {
          customElements.define('cart-items', CartItems);
        }
      }

      if (typeof callback == 'function'){
        callback()
      }
    })
    .catch(function (err) {
      console.warn('Something went wrong.', err);
    });
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink || cartLink.hasAttribute('data-cart-drawer-bound')) return;

    cartLink.setAttribute('data-cart-drawer-bound', 'true');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');

    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      if (!this.querySelector('#CartDrawer')) return this.loadCartDrawerSection(() => this.open(cartLink));
      this.open(cartLink);
    });

    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() !== 'SPACE') return;
      event.preventDefault();
      if (!this.querySelector('#CartDrawer')) return this.loadCartDrawerSection(() => this.open(cartLink));
      this.open(cartLink);
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    this.classList.add('animate', 'active')


    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState, openDrawer = true) {
    const self = this;
    if(!this.loaded){
      self.loadCartDrawerSection(() => renderContents(openDrawer));
    }
    else {
      renderContents(openDrawer)
    }

    function renderContents(shouldOpen = true){
      self.querySelector('.drawer__inner') && self.querySelector('.drawer__inner').classList.contains('is-empty') && self.querySelector('.drawer__inner').classList.remove('is-empty');
      self.productId = parsedState.id;

      if (parsedState.item_count !== undefined) {
        const cartCountBubble = document.getElementById('cart-count-bubble-to-update');
        if (cartCountBubble) {
          cartCountBubble.textContent = parsedState.item_count;
          const bubbleWrapper = cartCountBubble.closest('.cart-count-bubble');
          if (bubbleWrapper) {
            bubbleWrapper.classList.toggle('hidden', parsedState.item_count === 0);
          }
        }
      }

      self.getSectionsToRender().forEach((section => {
        const elementID = document.getElementById(section.id);
        let sectionElement = elementID;
        if (elementID && section.selector) {
          sectionElement = elementID.querySelector(section.selector) || elementID;
        }
        
        if (!sectionElement && section.id === 'cart-drawer') {
          sectionElement = self;
        }

        const html = parsedState.sections[section.section || section.id];
        if (sectionElement && html) {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const newElement = section.selector ? doc.querySelector(section.selector) : doc.querySelector('.shopify-section');
          
          if (newElement) {
            sectionElement.innerHTML = newElement.innerHTML;
            
            // Sync classes if we are updating the cart-drawer element itself
            if (section.id === 'cart-drawer' || sectionElement.tagName.toLowerCase() === 'cart-drawer') {
              const classesToKeep = ['active', 'animate'];
              const currentClasses = Array.from(sectionElement.classList).filter(c => classesToKeep.includes(c));
              sectionElement.className = newElement.className;
              currentClasses.forEach(c => sectionElement.classList.add(c));
            }
          } else {
            sectionElement.innerHTML = self.getSectionInnerHTML(html, section.selector);
          }
        }
      }));

      setTimeout(() => {
        if (self.querySelector('#CartDrawer-Overlay')) {
          self.querySelector('#CartDrawer-Overlay').addEventListener('click', self.close.bind(self));
        }
        if (shouldOpen) self.open();
      });
    }

  }

  getSectionInnerHTML(html, selector) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const element = selector ? doc.querySelector(selector) : doc.querySelector('.shopify-section');
    return element ? element.innerHTML : doc.body.innerHTML;
  }

  getSectionsToRender() {
    const sections = [
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-drawer',
        section: 'cart-drawer',
        selector: 'cart-drawer'
      }
    ];

    if (document.getElementById('main-cart-items')) {
      sections.push({
        id: 'main-cart-items',
        section: 'main-cart-items',
        selector: '#main-cart-items'
      });
    }

    if (document.getElementById('main-cart-footer')) {
      sections.push({
        id: 'main-cart-footer',
        section: 'main-cart-footer',
        selector: '#main-cart-footer'
      });
    }

    return sections;
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

document.addEventListener('DOMContentLoaded', (event) => {
  let cartDrawerSection = document.querySelector('cart-drawer');
  if (cartDrawerSection) {
    let cartDrawerContent = document.getElementById('CartDrawer');
    if (!cartDrawerContent && !cartDrawerSection.loaded) {
      cartDrawerSection.loadCartDrawerSection();
    }
  }
});
